import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CampaignStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fitness-force-campaign-status',
  templateUrl: './campaign-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TagModule]
})
export class CampaignStatusComponent implements OnInit {

  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter();
  @Input() rowIndex = 0;
  rotateIconInactive = new BehaviorSubject<boolean>(false);
  rotateIconActive = new BehaviorSubject<boolean>(false);
  constructor() { }

  ngOnInit(): void {
  }


  getMode(value: any) {
    if (!value || value == 0) return null;
    else if (Object.keys(value).length == 0) {
      return null;
    } else {
        return CampaignStatus[value];
    }
  }

  executeAction(action: string, columnData: any)
  {
    
    if(action == 'inactive')
    {
      this.rotateIconInactive.next(true);
    }
    else
    {
      this.rotateIconActive.next(true);
    }
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
    setTimeout(() => {
      this.rotateIconInactive.next(false);
      this.rotateIconActive.next(false);
    }, 100);
  }

  public get campaignStatus()
  {
    return CampaignStatus;
  }

}